import { Button, Row } from 'reactstrap';
import styled from 'styled-components';

export const ActionButtonGroup = styled(Row)`
  display: flex;
  width: 100%;
  flex-direction: row nowrap;
  justify-content: flex-end;
`;

export const ActionButton = styled(Button)`
  color: ${(props) => props.color};
  border: none;
  background: #fff;
  cursor: pointer;

  :hover {
    background: ${(props) => props.backgroundcolor};
    color: #fff;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/Notification/NotificationButton/NotificationButton.style.js